import React, { useContext, useState } from "react";
import Swal from "sweetalert2";
import LoadingIcon from "../../images/Loading_icon.gif";
import { UrlContext } from "../../contexts/UrlContext";

export default function SendEmail({
  expert,
  project_id,
  project_name,
  emailCount,
  setEmailCount,
  exObject,
  setEmailDetails,
  setComposeEmail,
}) {
  const [loadingPopup, setLoadingPopup] = useState(false);
  const { API_URL } = useContext(UrlContext);
  const sendEmailHander = () => {
    setLoadingPopup(true);
    const data = {
      expert_id: expert.ID,
      expert_name: exObject.expertName,
      expert_email: exObject.expertEmail,
      project_id,
      project_name,
    };
    const tokenObj = localStorage.getItem("eph-token");
    const token = JSON.parse(tokenObj).value;
    const url = `${API_URL}send-email-from-list`;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoadingPopup(false);
        if (data.status === "success") {
          setEmailDetails(data.emailDetails);
          setComposeEmail(true);
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        }
      })
      .catch((err) => {
        setLoadingPopup(false);
        console.log(err);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Database connection failed!",
        });
      });
  };

  return (
    <>
      <button
        className="btn"
        style={{ width: "130px" }}
        onClick={() => {
          sendEmailHander();
        }}
      >
        <i className="fa-regular fa-envelope" title="Click to Email" /> Email
      </button>

      {loadingPopup && (
        <div className="deletePrj-popup-wrapper">
          <div className="tab-pane fade show deletePrj-div">
            <center>
              <p style={{ fontSize: "18px" }}>Please wait . . .</p>
              <br />
              <img
                src={LoadingIcon}
                alt=""
                style={{ width: "50px", marginRight: "5px" }}
              />
            </center>
          </div>
        </div>
      )}
    </>
  );
}
